import { render } from "./HighLights.vue?vue&type=template&id=6974fefd&scoped=true&ts=true"
import script from "./HighLights.vue?vue&type=script&lang=ts"
export * from "./HighLights.vue?vue&type=script&lang=ts"

import "./HighLights.vue?vue&type=style&index=0&id=6974fefd&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6974fefd"]])

export default __exports__